export default __webpack_public_path__ + "static/media/mx.ceb499c1.svg";